module.exports = __webpack_public_path__ + "static/media/coupe3.2b8f8d62.png";